import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { v4 as uuidV4 } from 'uuid';
import entityComposition from '../../common/classes/entityComposition';
import entityDropdownButtonFactory from '../../common/lookups/entityDropdownButtonFactory';
import ContractSpecSaltTestItem from './contractSpecSaltTestItem';
const SaltTypeDropdown = entityDropdownButtonFactory('saltType');
class ContractSpecSaltTest extends Component {
  constructor(props) {
    super(props);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  componentDidMount() {
    const _this$props = this.props,
      saltTestTypeActions = _this$props.saltTestTypeActions,
      saltTestType = _this$props.saltTestType,
      saltTypeActions = _this$props.saltTypeActions,
      saltType = _this$props.saltType,
      saltUnitActions = _this$props.saltUnitActions,
      saltUnit = _this$props.saltUnit;
    saltTestTypeActions.serverIndex(saltTestType.indexQuery);
    saltTypeActions.serverIndex(saltType.indexQuery);
    saltUnitActions.serverIndex(saltUnit.indexQuery);
  }
  handleAdd(saltType) {
    const _this$props2 = this.props,
      userID = _this$props2.userID,
      active = _this$props2.active,
      onChange = _this$props2.onChange;
    // create a new salt test and add it to the array of existing saltTests
    const newSaltTest = {
      id: uuidV4().toUpperCase(),
      appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
      appCreatorID: userID,
      contractSpecID: active.id,
      saltTypeID: saltType.id
    };
    const saltTests = active.saltTests;
    saltTests.push(newSaltTest);
    onChange('saltTests', saltTests);
  }
  handleChange(index, name, value) {
    const onChange = this.props.onChange;
    onChange("saltTests[".concat(index, "]/").concat(name), value);
  }
  handleRemove(index) {
    const _this$props3 = this.props,
      active = _this$props3.active,
      onChange = _this$props3.onChange;
    const saltTests = JSON.parse(JSON.stringify(active.saltTests));
    saltTests.splice(index, 1);
    onChange('saltTests', saltTests);
  }
  render() {
    const _this$props4 = this.props,
      active = _this$props4.active,
      saltTestType = _this$props4.saltTestType,
      saltType = _this$props4.saltType,
      saltUnit = _this$props4.saltUnit;
    return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, "Salt Test"), /*#__PURE__*/React.createElement("hr", null), active.saltTests ? active.saltTests.map((item, index) => /*#__PURE__*/React.createElement(ContractSpecSaltTestItem, {
      active: item,
      index: index,
      key: item.id,
      onChange: this.handleChange,
      onRemove: this.handleRemove,
      saltTestTypeList: saltTestType.list,
      saltTypeList: saltType.list,
      saltUnitList: saltUnit.list
    })) : undefined // null
    , /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement(SaltTypeDropdown, {
      entity: "SaltType",
      list: saltType.list,
      onAdd: this.handleAdd,
      title: "Add Test"
    }))));
  }
}
ContractSpecSaltTest.propTypes = {
  active: PropTypes.shape({
    id: PropTypes.string,
    saltTests: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  saltTestType: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  saltTestTypeActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  saltType: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  saltTypeActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  saltUnit: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  saltUnitActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  userID: PropTypes.string.isRequired
};
export { ContractSpecSaltTest as TestContractSpecSaltTest };
export default entityComposition(ContractSpecSaltTest, ['saltTestType', 'saltType', 'saltUnit'], {});